import React, { useState, useEffect } from 'react';
import './about.scss';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useQuery } from 'react-query';
import { Skeleton } from '@mui/material';
import config from '../../config';

const fetchUserData = async (activeUserId) => {
  if (!activeUserId) {
    return null;
  }

  const url = `${config.apiBaseUrl}admins/users/${activeUserId}/business-profiles`;

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${Cookies.get('authToken')}`
  };

  const response = await axios.get(url, { headers });
  return response.data;
};

const About = ({ activeUserId }) => {
  const [brandName, setBrandName] = useState('');
  const [businessType, setbusinessType] = useState('');
  const [description, setDescription] = useState('');
  const [site, setSite] = useState('');
  const [industry, setIndustry] = useState('');
  const [location, setLocation] = useState('');
  const [completedAboutPercent, setCompletedAboutPercent] = useState('');
  const [avgCheck, setAvgCheck] = useState('');
  const [orderAmount, setOrderAmount] = useState('');
  const [orderGoal, setOrderGoal] = useState('');
  const [timeline, setTimeline] = useState('');
  const [completedFinancePercent, setCompletedFinancePercent] = useState('');
  const [gender, setGender] = useState('');
  const [age, setAge] = useState('');
  const [channels, setChannels] = useState('');
  const [completedChannelsPercent, setCompletedChannelsPercent] = useState('');
  const {
    isLoading: isLoading,
    error: error,
    data: aboutData
  } = useQuery(['userAbout', activeUserId], () => fetchUserData(activeUserId));

  useEffect(() => {
    if (!isLoading && !error && aboutData) {
      let completedAbout = 0;
      let completedFinance = 0;

      if (aboutData.items[0]) {
        if (aboutData.items[0].companyName) {
          setBrandName(aboutData.items[0].companyName);
          completedAbout = completedAbout + 1;
        } else {
          setBrandName('-');
        }
        if (aboutData.items[0].productsType) {
          completedAbout = completedAbout + 1;
          setbusinessType(aboutData.items[0].productsType);
        } else {
          setbusinessType('-');
        }
        if (aboutData.items[0].companyDescription) {
          completedAbout = completedAbout + 1;
          setDescription(aboutData.items[0].companyDescription);
        } else {
          setDescription('-');
        }
        if (aboutData.items[0].siteDomain) {
          completedAbout = completedAbout + 1;
          setSite(aboutData.items[0].siteDomain);
        } else {
          setSite('-');
        }
        if (aboutData.items[0].businessArea) {
          completedAbout = completedAbout + 1;
          setIndustry(aboutData.items[0].businessArea);
        } else {
          setIndustry('-');
        }
        if (aboutData.items[0].companyAddress) {
          completedAbout = completedAbout + 1;
          setLocation(aboutData.items[0].companyAddress);
        } else {
          setLocation('-');
        }
        if (aboutData.items[0].ordersPerMonth) {
          completedFinance = completedFinance + 1;
          setOrderAmount(aboutData.items[0].ordersPerMonth);
        } else {
          setOrderAmount('-');
        }
        if (aboutData.items[0].averageCheck) {
          completedFinance = completedFinance + 1;
          setAvgCheck(aboutData.items[0].averageCheck);
        } else {
          setAvgCheck('-');
        }
        if (aboutData.items[0].ordersGoal) {
          completedFinance = completedFinance + 1;
          setOrderGoal(aboutData.items[0].ordersGoal);
        } else {
          setOrderGoal('-');
        }
        if (aboutData.items[0].ordersGoalPeriod) {
          completedFinance = completedFinance + 1;
          setTimeline(aboutData.items[0].ordersGoalPeriod);
        } else {
          setTimeline('-');
        }
        if (aboutData.items[0].sellChannels) {
          setChannels(aboutData.items[0].sellChannels);
          setCompletedChannelsPercent(100);
        } else {
          setChannels('-');
          setCompletedChannelsPercent(0);
        }
        setCompletedAboutPercent((100 * completedAbout) / 6);
        setCompletedFinancePercent((100 * completedFinance) / 4);
        setGender('-');
        setAge('-');
      }
    }
  }, [isLoading, error, aboutData]);
  return (
    <div className="about">
      <div className="about-block">
        <div className="about-block-top">
          <div className="about-block__title">About Company</div>
          <div className="about-block__complete">
            {Math.round(completedAboutPercent)}% completed
          </div>
          <div className="about-block__progress">
            <span style={{ width: `${completedAboutPercent}%` }}></span>
          </div>
        </div>
        <div className="about-block-wrapper">
          <div className="about-block-item">
            <span>Brand name</span>
            {isLoading ? (
              <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
            ) : (
              <p>{brandName}</p>
            )}
          </div>
          <div className="about-block-item" style={{ gridColumn: 'span 3' }}>
            <span>Company description</span>
            {isLoading ? (
              <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
            ) : (
              <p>{description}</p>
            )}
          </div>
          <div className="about-block-item">
            <span>Business type</span>
            {isLoading ? (
              <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
            ) : (
              <p>{businessType}</p>
            )}
          </div>
          <div className="about-block-item">
            <span>Default site</span>
            {isLoading ? (
              <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
            ) : (
              <p>{site}</p>
            )}
          </div>
          <div className="about-block-item">
            <span>Business industry</span>
            {isLoading ? (
              <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
            ) : (
              <p>{industry}</p>
            )}
          </div>
          <div className="about-block-item">
            <span>Location</span>
            {isLoading ? (
              <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
            ) : (
              <p>{location}</p>
            )}
          </div>
        </div>
      </div>
      <div className="about-block">
        <div className="about-block-top">
          <div className="about-block__title">Financial Information</div>
          <div className="about-block__complete">
            {Math.round(completedFinancePercent)}% completed
          </div>
          <div className="about-block__progress">
            <span style={{ width: `${Math.round(completedFinancePercent)}%` }}></span>
          </div>
        </div>
        <div className="about-block-wrapper">
          <div className="about-block-item">
            <span>Average check</span>
            {isLoading ? (
              <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
            ) : (
              <p>{avgCheck}</p>
            )}
          </div>
          <div className="about-block-item">
            <span>Monthly order amount</span>
            {isLoading ? (
              <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
            ) : (
              <p>{orderAmount}</p>
            )}
          </div>

          <div className="about-block-item">
            <span>Monthly order goal</span>
            {isLoading ? (
              <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
            ) : (
              <p>{orderGoal}</p>
            )}
          </div>
          <div className="about-block-item">
            <span>Order goal timeline</span>
            {isLoading ? (
              <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
            ) : (
              <p>{timeline}</p>
            )}
          </div>
        </div>
      </div>
      <div className="about-bottom">
        <div className="about-block">
          <div className="about-block-top">
            <div className="about-block__title">Audience</div>
            <div className="about-block__complete">0% completed</div>
            <div className="about-block__progress">
              <span style={{ width: '0%' }}></span>
            </div>
          </div>
          <div className="about-block-wrapper">
            <div className="about-block-item" style={{ gridColumn: 'span 2' }}>
              <span>Customer gender</span>
              {isLoading ? (
                <Skeleton variant="rounded" width={'100%'} height={'19.2'} />
              ) : (
                <p>{gender}</p>
              )}
            </div>
            <div className="about-block-item" style={{ gridColumn: 'span 2' }}>
              <span>Age of your clients</span>
              {isLoading ? (
                <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
              ) : (
                <p>{age}</p>
              )}
            </div>
          </div>
        </div>
        <div className="about-block">
          <div className="about-block-top">
            <div className="about-block__title">Sales channel</div>
            <div className="about-block__complete">
              {Math.round(completedChannelsPercent)}% completed
            </div>
            <div className="about-block__progress">
              <span style={{ width: `${Math.round(completedChannelsPercent)}%` }}></span>
            </div>
          </div>
          <div className="about-block-wrapper">
            <div className="about-block-item" style={{ gridColumn: 'span 4' }}>
              <span>Social media</span>
              {isLoading ? (
                <Skeleton variant="rounded" width={'100%'} height={'19.2rem'} />
              ) : (
                <ul>
                  {channels.includes('Facebook') && (
                    <li>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10.0011 0.90625C15.0218 0.90625 19.092 4.9764 19.092 9.99716C19.092 15.0179 15.0218 19.0881 10.0011 19.0881C4.9803 19.0881 0.910156 15.0179 0.910156 9.99716C0.910156 4.9764 4.9803 0.90625 10.0011 0.90625Z"
                          fill="url(#paint0_linear_3113_40071)"
                        />
                        <path
                          d="M11.1844 19.0124V11.9904H13.164L13.4264 9.51901H11.1844L11.1877 8.28196C11.1877 7.63736 11.2489 7.29214 12.1748 7.29214H13.4125V4.82031H11.4324C9.05402 4.82031 8.21701 6.01915 8.21701 8.03552V9.5192H6.73438V11.9908H8.21701V18.9128C8.7946 19.0279 9.39174 19.0887 10.0031 19.0887C10.3981 19.0887 10.7927 19.0632 11.1844 19.0124Z"
                          fill="white"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_3113_40071"
                            x1="10.0011"
                            y1="0.740605"
                            x2="10.0011"
                            y2="19.8633"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#00B2FF" />
                            <stop offset="1" stopColor="#006AFF" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </li>
                  )}
                  {channels.includes('Instagram') && (
                    <li>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.97125 9.99716C6.97125 8.32363 8.32754 6.96661 10.0011 6.96661C11.6746 6.96661 13.0316 8.32363 13.0316 9.99716C13.0316 11.6707 11.6746 13.0277 10.0011 13.0277C8.32754 13.0277 6.97125 11.6707 6.97125 9.99716ZM5.33299 9.99716C5.33299 12.5753 7.42288 14.6652 10.0011 14.6652C12.5792 14.6652 14.6691 12.5753 14.6691 9.99716C14.6691 7.41898 12.5792 5.32909 10.0011 5.32909C7.42288 5.32909 5.33299 7.41898 5.33299 9.99716ZM13.763 5.144C13.7629 5.35976 13.8268 5.5707 13.9466 5.75015C14.0664 5.92959 14.2368 6.06949 14.4361 6.15213C14.6354 6.23478 14.8547 6.25647 15.0663 6.21446C15.278 6.17246 15.4724 6.06863 15.625 5.91613C15.7776 5.76362 15.8816 5.56928 15.9238 5.35769C15.966 5.14609 15.9445 4.92673 15.862 4.72736C15.7795 4.52799 15.6397 4.35756 15.4604 4.23762C15.281 4.11767 15.0701 4.05361 14.8544 4.05352H14.8539C14.5647 4.05366 14.2874 4.16858 14.0829 4.37304C13.8783 4.5775 13.7633 4.85479 13.763 5.144ZM6.32834 17.3969C5.44201 17.3566 4.96027 17.2089 4.64012 17.0842C4.21568 16.919 3.91285 16.7222 3.59445 16.4042C3.27605 16.0863 3.07896 15.7837 2.91445 15.3593C2.78965 15.0393 2.64201 14.5574 2.60172 13.6711C2.55765 12.7128 2.54885 12.4249 2.54885 9.99723C2.54885 7.56952 2.55837 7.28247 2.60172 6.32341C2.64208 5.43709 2.79081 4.95614 2.91445 4.6352C3.07968 4.21076 3.27648 3.90792 3.59445 3.58952C3.91241 3.27112 4.21496 3.07403 4.64012 2.90952C4.96012 2.78472 5.44201 2.63709 6.32834 2.5968C7.28659 2.55272 7.57445 2.54392 10.0011 2.54392C12.4277 2.54392 12.7158 2.55345 13.6749 2.5968C14.5612 2.63716 15.0422 2.78589 15.3631 2.90952C15.7875 3.07403 16.0904 3.27156 16.4088 3.58952C16.7272 3.90749 16.9235 4.21076 17.0888 4.6352C17.2136 4.9552 17.3612 5.43709 17.4015 6.32341C17.4456 7.28247 17.4544 7.56952 17.4544 9.99723C17.4544 12.4249 17.4456 12.712 17.4015 13.6711C17.3611 14.5574 17.2128 15.0391 17.0888 15.3593C16.9235 15.7837 16.7267 16.0865 16.4088 16.4042C16.0908 16.7219 15.7875 16.919 15.3631 17.0842C15.0431 17.209 14.5612 17.3566 13.6749 17.3969C12.7166 17.441 12.4288 17.4498 10.0011 17.4498C7.57336 17.4498 7.2863 17.441 6.32834 17.3969ZM6.25307 0.961305C5.28528 1.00538 4.62397 1.15883 4.04645 1.38356C3.44834 1.61563 2.94201 1.92698 2.43605 2.43214C1.93008 2.9373 1.61954 3.44443 1.38747 4.04254C1.16274 4.62043 1.00928 5.28138 0.965211 6.24916C0.920411 7.21847 0.910156 7.52836 0.910156 9.99716C0.910156 12.466 0.920411 12.7759 0.965211 13.7452C1.00928 14.713 1.16274 15.3739 1.38747 15.9518C1.61954 16.5495 1.93016 17.0572 2.43605 17.5622C2.94194 18.0671 3.44834 18.378 4.04645 18.6108C4.62507 18.8355 5.28528 18.9889 6.25307 19.033C7.22288 19.0771 7.53227 19.0881 10.0011 19.0881C12.4699 19.0881 12.7798 19.0778 13.7491 19.033C14.7169 18.9889 15.3778 18.8355 15.9557 18.6108C16.5534 18.378 17.0601 18.0673 17.5661 17.5622C18.072 17.057 18.3819 16.5495 18.6147 15.9518C18.8394 15.3739 18.9936 14.7129 19.0369 13.7452C19.081 12.7751 19.0912 12.466 19.0912 9.99716C19.0912 7.52836 19.081 7.21847 19.0369 6.24916C18.9928 5.2813 18.8394 4.62007 18.6147 4.04254C18.3819 3.4448 18.0712 2.9381 17.5661 2.43214C17.0609 1.92618 16.5534 1.61563 15.9564 1.38356C15.3778 1.15883 14.7168 1.00465 13.7498 0.961305C12.7805 0.917232 12.4706 0.90625 10.0018 0.90625C7.53299 0.90625 7.22288 0.916505 6.25307 0.961305Z"
                          fill="url(#paint0_radial_3113_40075)"
                        />
                        <path
                          d="M6.97125 9.99716C6.97125 8.32363 8.32754 6.96661 10.0011 6.96661C11.6746 6.96661 13.0316 8.32363 13.0316 9.99716C13.0316 11.6707 11.6746 13.0277 10.0011 13.0277C8.32754 13.0277 6.97125 11.6707 6.97125 9.99716ZM5.33299 9.99716C5.33299 12.5753 7.42288 14.6652 10.0011 14.6652C12.5792 14.6652 14.6691 12.5753 14.6691 9.99716C14.6691 7.41898 12.5792 5.32909 10.0011 5.32909C7.42288 5.32909 5.33299 7.41898 5.33299 9.99716ZM13.763 5.144C13.7629 5.35976 13.8268 5.5707 13.9466 5.75015C14.0664 5.92959 14.2368 6.06949 14.4361 6.15213C14.6354 6.23478 14.8547 6.25647 15.0663 6.21446C15.278 6.17246 15.4724 6.06863 15.625 5.91613C15.7776 5.76362 15.8816 5.56928 15.9238 5.35769C15.966 5.14609 15.9445 4.92673 15.862 4.72736C15.7795 4.52799 15.6397 4.35756 15.4604 4.23762C15.281 4.11767 15.0701 4.05361 14.8544 4.05352H14.8539C14.5647 4.05366 14.2874 4.16858 14.0829 4.37304C13.8783 4.5775 13.7633 4.85479 13.763 5.144ZM6.32834 17.3969C5.44201 17.3566 4.96027 17.2089 4.64012 17.0842C4.21568 16.919 3.91285 16.7222 3.59445 16.4042C3.27605 16.0863 3.07896 15.7837 2.91445 15.3593C2.78965 15.0393 2.64201 14.5574 2.60172 13.6711C2.55765 12.7128 2.54885 12.4249 2.54885 9.99723C2.54885 7.56952 2.55837 7.28247 2.60172 6.32341C2.64208 5.43709 2.79081 4.95614 2.91445 4.6352C3.07968 4.21076 3.27648 3.90792 3.59445 3.58952C3.91241 3.27112 4.21496 3.07403 4.64012 2.90952C4.96012 2.78472 5.44201 2.63709 6.32834 2.5968C7.28659 2.55272 7.57445 2.54392 10.0011 2.54392C12.4277 2.54392 12.7158 2.55345 13.6749 2.5968C14.5612 2.63716 15.0422 2.78589 15.3631 2.90952C15.7875 3.07403 16.0904 3.27156 16.4088 3.58952C16.7272 3.90749 16.9235 4.21076 17.0888 4.6352C17.2136 4.9552 17.3612 5.43709 17.4015 6.32341C17.4456 7.28247 17.4544 7.56952 17.4544 9.99723C17.4544 12.4249 17.4456 12.712 17.4015 13.6711C17.3611 14.5574 17.2128 15.0391 17.0888 15.3593C16.9235 15.7837 16.7267 16.0865 16.4088 16.4042C16.0908 16.7219 15.7875 16.919 15.3631 17.0842C15.0431 17.209 14.5612 17.3566 13.6749 17.3969C12.7166 17.441 12.4288 17.4498 10.0011 17.4498C7.57336 17.4498 7.2863 17.441 6.32834 17.3969ZM6.25307 0.961305C5.28528 1.00538 4.62397 1.15883 4.04645 1.38356C3.44834 1.61563 2.94201 1.92698 2.43605 2.43214C1.93008 2.9373 1.61954 3.44443 1.38747 4.04254C1.16274 4.62043 1.00928 5.28138 0.965211 6.24916C0.920411 7.21847 0.910156 7.52836 0.910156 9.99716C0.910156 12.466 0.920411 12.7759 0.965211 13.7452C1.00928 14.713 1.16274 15.3739 1.38747 15.9518C1.61954 16.5495 1.93016 17.0572 2.43605 17.5622C2.94194 18.0671 3.44834 18.378 4.04645 18.6108C4.62507 18.8355 5.28528 18.9889 6.25307 19.033C7.22288 19.0771 7.53227 19.0881 10.0011 19.0881C12.4699 19.0881 12.7798 19.0778 13.7491 19.033C14.7169 18.9889 15.3778 18.8355 15.9557 18.6108C16.5534 18.378 17.0601 18.0673 17.5661 17.5622C18.072 17.057 18.3819 16.5495 18.6147 15.9518C18.8394 15.3739 18.9936 14.7129 19.0369 13.7452C19.081 12.7751 19.0912 12.466 19.0912 9.99716C19.0912 7.52836 19.081 7.21847 19.0369 6.24916C18.9928 5.2813 18.8394 4.62007 18.6147 4.04254C18.3819 3.4448 18.0712 2.9381 17.5661 2.43214C17.0609 1.92618 16.5534 1.61563 15.9564 1.38356C15.3778 1.15883 14.7168 1.00465 13.7498 0.961305C12.7805 0.917232 12.4706 0.90625 10.0018 0.90625C7.53299 0.90625 7.22288 0.916505 6.25307 0.961305Z"
                          fill="url(#paint1_radial_3113_40075)"
                        />
                        <defs>
                          <radialGradient
                            id="paint0_radial_3113_40075"
                            cx="0"
                            cy="0"
                            r="1"
                            gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(3.32572 19.174) scale(23.7348 23.7348)"
                          >
                            <stop offset="0.09" stopColor="#FA8F21" />
                            <stop offset="0.78" stopColor="#D82D7E" />
                          </radialGradient>
                          <radialGradient
                            id="paint1_radial_3113_40075"
                            cx="0"
                            cy="0"
                            r="1"
                            gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(11.9366 19.9885) scale(18.7063)"
                          >
                            <stop offset="0.64" stopColor="#8C3AAA" stopOpacity="0" />
                            <stop offset="1" stopColor="#8C3AAA" />
                          </radialGradient>
                        </defs>
                      </svg>
                    </li>
                  )}

                  {channels.includes('Pinterest') && (
                    <li>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.6172 9.75979C18.6172 14.6487 14.6526 18.6133 9.76369 18.6133C4.8748 18.6133 0.910156 14.6487 0.910156 9.75979C0.910156 4.8709 4.8748 0.90625 9.76369 0.90625C14.6526 0.90625 18.6172 4.8709 18.6172 9.75979Z"
                          fill="#CA2127"
                        />
                        <path
                          d="M9.0225 3.86896C6.52755 4.13664 4.04271 6.05583 3.9417 8.8033C3.87604 10.4801 4.57806 11.7376 6.25483 12.0912C6.44675 11.2983 6.4821 10.869 6.4821 10.869C6.4821 10.869 5.74473 10.1619 5.66897 9.71239C5.05281 6.09623 10.0478 3.62653 12.669 6.15179C14.477 7.90431 13.2851 13.2932 10.3659 12.7326C7.56796 12.1972 11.7346 7.90936 9.5023 7.06593C7.68917 6.37906 6.72452 9.16189 7.58311 10.5407C7.07806 12.9144 5.9922 15.1518 6.43159 18.1265C7.86089 17.1417 8.34069 15.2528 8.73462 13.2831C9.4518 13.6972 9.83563 14.1316 10.7498 14.1972C14.1235 14.4447 16.0074 10.9902 15.5478 7.79825C15.1336 4.96997 12.174 3.53058 9.0225 3.86896Z"
                          fill="white"
                        />
                      </svg>
                    </li>
                  )}

                  {channels.includes('Google') && (
                    <li>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.8 10.2188C18.8 9.56875 18.7417 8.94375 18.6333 8.34375H10V11.8938H14.9333C14.7167 13.0354 14.0667 14.0021 13.0917 14.6521V16.9604H16.0667C17.8 15.3604 18.8 13.0104 18.8 10.2188Z"
                          fill="#4285F4"
                        />
                        <path
                          d="M9.99974 19.1745C12.4747 19.1745 14.5497 18.3578 16.0664 16.9578L13.0914 14.6495C12.2747 15.1995 11.2331 15.5328 9.99974 15.5328C7.61641 15.5328 5.59141 13.9245 4.86641 11.7578H1.81641V14.1245C3.32474 17.1161 6.41641 19.1745 9.99974 19.1745Z"
                          fill="#34A853"
                        />
                        <path
                          d="M4.86536 11.7328C4.68203 11.1828 4.5737 10.5995 4.5737 9.99115C4.5737 9.38281 4.68203 8.79948 4.86536 8.24948V5.88281H1.81536C1.19036 7.11615 0.832031 8.50781 0.832031 9.99115C0.832031 11.4745 1.19036 12.8661 1.81536 14.0995L4.19036 12.2495L4.86536 11.7328Z"
                          fill="#FBBC05"
                        />
                        <path
                          d="M9.99974 4.49375C11.3497 4.49375 12.5497 4.96042 13.5081 5.86042L16.1331 3.23542C14.5414 1.75208 12.4747 0.84375 9.99974 0.84375C6.41641 0.84375 3.32474 2.90208 1.81641 5.90208L4.86641 8.26875C5.59141 6.10208 7.61641 4.49375 9.99974 4.49375Z"
                          fill="#EA4335"
                        />
                      </svg>
                    </li>
                  )}

                  {channels.includes('TikTok') && (
                    <li>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.621 19.0887H5.38113C2.91204 19.0887 0.910156 17.0868 0.910156 14.6171V5.37722C0.910156 2.90813 2.91204 0.90625 5.38113 0.90625H14.621C17.0901 0.90625 19.092 2.90813 19.092 5.37722V14.6171C19.0926 17.0868 17.0907 19.0887 14.621 19.0887Z"
                          fill="black"
                        />
                        <path
                          d="M8.44683 8.65239V8.10393C8.25649 8.07382 8.06425 8.05737 7.87157 8.0547C6.00617 8.05096 4.35518 9.25944 3.79488 11.0382C3.23457 12.817 3.89584 14.754 5.42655 15.8192C3.82043 14.1002 3.91205 11.4047 5.63098 9.79855C6.39692 9.08355 7.39928 8.67555 8.44683 8.65239Z"
                          fill="#25F4EE"
                        />
                        <path
                          d="M8.54903 14.8595C9.59173 14.8583 10.4487 14.0369 10.4948 12.9948V3.69772H12.1932C12.1584 3.50357 12.142 3.3066 12.1439 3.10938H9.82108V12.3971C9.78244 13.4441 8.92298 14.2737 7.87529 14.2756C7.56242 14.2731 7.25391 14.1958 6.97656 14.0512C7.15641 14.3003 7.3926 14.5034 7.66587 14.6439C7.93915 14.7844 8.24176 14.8583 8.54903 14.8595ZM15.3649 6.852V6.33533C14.7398 6.33533 14.1284 6.15084 13.608 5.80494C14.0642 6.33575 14.681 6.70334 15.3649 6.852Z"
                          fill="#25F4EE"
                        />
                        <path
                          d="M13.6121 5.7997C13.0991 5.21571 12.8163 4.46483 12.8168 3.6875H12.1967C12.2765 4.11733 12.4432 4.52635 12.6866 4.88953C12.93 5.25271 13.2449 5.56242 13.6121 5.7997ZM7.8738 10.3694C6.79682 10.375 5.92801 11.2525 5.93362 12.3295C5.9354 12.683 6.03324 13.0294 6.21669 13.3317C6.40013 13.6339 6.66227 13.8806 6.97507 14.0453C6.34497 13.1753 6.53942 11.9587 7.40948 11.3279C7.74192 11.0872 8.14205 10.9578 8.55253 10.9584C8.7476 10.9609 8.94144 10.9914 9.12779 11.0487V8.68473C8.9377 8.65606 8.74511 8.64111 8.55253 8.63986H8.44907V10.4373C8.26147 10.3862 8.06764 10.3638 7.8738 10.3694Z"
                          fill="#FE2C55"
                        />
                        <path
                          d="M15.3687 6.85156V8.64902C14.2115 8.6468 13.0844 8.28047 12.1471 7.60196V12.3243C12.1421 14.6809 10.2306 16.5886 7.87408 16.5886C6.99892 16.5903 6.14483 16.3203 5.42969 15.8158C7.03331 17.5403 9.73137 17.6388 11.4565 16.0352C11.8857 15.6363 12.228 15.1531 12.4621 14.616C12.6962 14.0789 12.817 13.4992 12.8171 12.9133V8.20402C13.7577 8.87775 14.8861 9.2392 16.043 9.23737V6.92386C15.8162 6.92261 15.5906 6.89893 15.3687 6.85156Z"
                          fill="#FE2C55"
                        />
                        <path
                          d="M12.1482 12.3195V7.59716C13.0885 8.27143 14.2171 8.63293 15.3741 8.63051V6.83305C14.6906 6.68854 14.0725 6.32589 13.6128 5.7997C13.2458 5.56222 12.931 5.25246 12.6877 4.88931C12.4443 4.52617 12.2775 4.11724 12.1974 3.6875H10.4991V12.9889C10.4548 14.0653 9.54735 14.9017 8.471 14.858C8.17653 14.8461 7.88861 14.7675 7.62888 14.6283C7.36915 14.489 7.14437 14.2927 6.97145 14.0541C6.0185 13.5523 5.65265 12.3731 6.15437 11.4202C6.31902 11.1073 6.56567 10.8451 6.86792 10.6616C7.17017 10.4782 7.51662 10.3804 7.87018 10.3787C8.06526 10.3806 8.25909 10.4105 8.44544 10.4685V8.64422C6.09329 8.68411 4.21855 10.6505 4.25844 13.0026C4.27648 14.0678 4.69297 15.0876 5.42579 15.8609C6.14795 16.3487 7.00322 16.6014 7.87455 16.5845C10.2317 16.5838 12.1432 14.6761 12.1482 12.3195Z"
                          fill="white"
                        />
                      </svg>
                    </li>
                  )}
                  {channels.includes('Other') && (
                    <li>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="10" cy="10" r="8.25" stroke="black" strokeWidth="1.5" />
                        <path
                          d="M10.6576 11.496V11.748H9.24356V11.44C9.24356 11.1133 9.31823 10.7913 9.46756 10.474C9.62623 10.1567 9.94356 9.732 10.4196 9.2C10.8209 8.74267 11.0822 8.402 11.2036 8.178C11.3249 7.94467 11.3856 7.716 11.3856 7.492C11.3856 7.16533 11.2549 6.89467 10.9936 6.68C10.7416 6.46533 10.4149 6.358 10.0136 6.358C9.6029 6.358 9.26223 6.47467 8.99156 6.708C8.73023 6.94133 8.59956 7.23067 8.59956 7.576V7.954H7.10156V7.562C7.10156 6.82467 7.38156 6.21333 7.94156 5.728C8.5109 5.24267 9.22023 5 10.0696 5C10.9002 5 11.5816 5.22867 12.1136 5.686C12.6456 6.14333 12.9116 6.73133 12.9116 7.45C12.9116 7.80467 12.8229 8.15933 12.6456 8.514C12.4776 8.86867 12.1276 9.34 11.5956 9.928C11.2036 10.3573 10.9469 10.6793 10.8256 10.894C10.7136 11.1087 10.6576 11.3093 10.6576 11.496ZM9.95756 12.798C10.2282 12.798 10.4569 12.896 10.6436 13.092C10.8396 13.2787 10.9376 13.5073 10.9376 13.778C10.9376 14.0393 10.8396 14.2633 10.6436 14.45C10.4569 14.6367 10.2282 14.73 9.95756 14.73C9.69623 14.73 9.47223 14.6367 9.28556 14.45C9.0989 14.2633 9.00556 14.0393 9.00556 13.778C9.00556 13.5073 9.0989 13.2787 9.28556 13.092C9.47223 12.896 9.69623 12.798 9.95756 12.798Z"
                          fill="black"
                        />
                      </svg>
                    </li>
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
